// extracted by mini-css-extract-plugin
module.exports = {"body":"ErrorPageLayout_body__SoXp6","container":"ErrorPageLayout_container__zLUqT","logoContainer":"ErrorPageLayout_logoContainer__BcgkN","footer":"ErrorPageLayout_footer__8i7yc"};